// Tratamento de falha das buscas das paginas de listagem.
//
// As 6 buscas que alimentam as tabelas (lista de arquivos importados em
// People/Groups/Occupations + lista de registros de cada arquivo nas 3 paginas
// de detalhe) e as 3 buscas de metadado do arquivo (`getProcessedXById`) nao
// tinham `.catch`: falha de API virava rejeicao NAO TRATADA (as chamadas sao
// fire-and-forget no `mounted`), a tabela ficava vazia e o usuario nao recebia
// NENHUMA mensagem — nao havia como distinguir "sem dados" de "a API caiu".
// Viola .claude/rules/frontend/quality-gates.md §8 (todo catch DEVE exibir
// feedback ao usuario e logar).
//
// O tratamento vive aqui, e nao repetido em cada chamada, porque o defeito era
// uniforme nos 3 modulos — mesmo padrao de extracao de `listing-table` e
// `upload-tab-selection`.
//
// Contrato do componente consumidor — como o alerta e ENTREGUE:
// - paginas de listagem (PeoplePage/GroupsPage/OccupationsPage) renderizam o
//   proprio <AlertBar> e definem `handleAlert({ type, message })`: o mixin
//   chama esse metodo direto;
// - paginas de detalhe (Imported*Page) NAO renderizam AlertBar — sao montadas
//   no <router-view> da listagem, que escuta `@alert`. Sem `handleAlert`
//   proprio, o mixin emite o evento `alert` com o MESMO shape que
//   confirmImportRecords/rejectImportRecords ja usam.
// Nenhuma Imported*Page define `handleAlert`, entao a escolha e deterministica.

const listingFetchErrorMixin = {
  methods: {
    /**
     * Fecha o caminho de erro de uma busca de listagem: loga e avisa o usuario.
     *
     * Usar SEMPRE antes do `.finally` que desliga o loading — assim o `.catch`
     * absorve a rejeicao, o loading e desligado e o metodo async NAO rejeita
     * (era a rejeicao nao tratada do `mounted`). Mesma ordem
     * `.then().catch().finally()` do confirm/reject que ja existia.
     *
     * @param {unknown} error erro recebido do service
     * @param {string} context nome da busca, so para o log (nao vai para a tela)
     */
    notifyListingFetchError(error, context) {
      // console.error (nao console.log) deixa rastro no devtools/monitoring —
      // mesmo criterio do LanguageMenu. Sem PII: so o nome da busca e o erro.
      console.error(`[sync] ${context} falhou`, error)

      const message = {
        type: 'error',
        message: this.$t('common.loadError'),
      }

      if (typeof this.handleAlert === 'function') {
        this.handleAlert(message)
        return
      }

      this.$emit('alert', message)
    },
  },
}

export { listingFetchErrorMixin }
